import { Component, OnInit } from '@angular/core';
import { AccessDecisionService } from '../service/AccessDecisionService'; // Path to the service
import { AccessDecision } from '../class/AutoLockAccess'; // Path to the model
import { BrandDetails, IBrandDetailsHF } from '../class/redact';
import { SubSink } from 'subsink';
import { RedactReplyServiceService } from '../service/redact-reply-service.service';
import { AppError } from '../common/class/app-error';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AppConfigService } from 'src/app/app-config.service';
@Component({
  selector: 'app-auto-lock-access',
  templateUrl: './auto-lock-access.component.html',
  styleUrls: ['./auto-lock-access.component.scss']
})
export class AutoLockAccessComponent implements OnInit {
 public accessDecision=new AccessDecision;
 logoId:string;
   public brandDetails=new BrandDetails;
   showLogo:boolean=true;
   companyLogoURL:string="";
   private subs = new SubSink();
   destShortURL:string;
   accessDeniedText : string;
   viewType : string;
   isDisappearInk : boolean;
   showCompanyLogo: boolean;
   contactSenderText: string;
   //accessbaseUrl: string;
   autolockAccessDecisionUrl: string;
   //routeUrl:string;
   //iframeUrl:string;
   public iframeUrl: SafeResourceUrl;
   themeValue: boolean;
  constructor(
    private accessDecisionService: AccessDecisionService,
    private user: RedactReplyServiceService, private http: HttpClient,private router:Router,
     private route: ActivatedRoute,private translate: TranslateService,
     private sanitizer: DomSanitizer,private config: AppConfigService
  ) {

    //this.accessbaseUrl = this.config.accessbaseUrl;
    this.autolockAccessDecisionUrl=this.config.accessbaseUrl+this.config.accessUrl;
    this.route.params.subscribe(params => {
     // this.destShortURL = params.shortURL;
      this.viewType = params.viewType.toString();
    });
   }

  ngOnInit() {
      // Retrieve the stored AccessDecision from the service
      this.accessDecision = this.accessDecisionService.getAccessDecision();
     // this.iframeUrl ="http://localhost:4200/AutolockAccessDecision";
      //const encodedMessage = btoa(JSON.stringify(this.accessDecision));
      const unsafeUrl = this.autolockAccessDecisionUrl;
      const baseUrl = new URL(unsafeUrl).origin;
      // this.restoreThankYouPage(); 
      this.handleIframeMessage(baseUrl);
    // Sanitizing the URL to allow Angular to trust it
    this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(unsafeUrl);
   
     // this.iframeUrl ="http://localhost:4300/AutolockAccessDecision/"+encodedMessage;
      if (this.accessDecision) {
        console.log('Access Decision:', this.accessDecision);
       // this.viewType = "RD";
      //  var data=localStorage.getItem('encodedString').toString();
       
       
        this.getBrandingDetails();
      
      window.addEventListener('message', this.handleMessage.bind(this, baseUrl));
      } else {
        console.log('No access decision data found');
      }
  }
  ngAfterViewInit(): void {
    // Ensure the iframe is loaded after the view initialization
    const unsafeUrl = this.autolockAccessDecisionUrl;
    const baseUrl = new URL(unsafeUrl).origin;
    window.addEventListener('message', this.handleMessage.bind(this, baseUrl));
    this.handleIframeMessage(baseUrl);
  }
    getBrandingDetails()
    {
     this.subs.sink = this.user.postUserInformation(this.accessDecision.Key,this.viewType)
      .subscribe(resp => {
               if (!(resp instanceof AppError)) {      
            const response = resp as IBrandDetailsHF;
             const result = response.ResultContent;
             this.brandDetails=result;
             if(this.brandDetails.Theme == 2){
              this.themeValue = false;
            }
            else{
              this.themeValue = true;
            }
              //this.themeValue = false;
          localStorage.setItem('themeValue', JSON.stringify(this.themeValue));
             this.accessDeniedText = "Access Denied";
             this.contactSenderText = "Please contact the sender for further information.";
             if(this.viewType == "RD")
             {
                this.isDisappearInk = false;
             }
             else if(this.viewType == "DI")
             {
                this.isDisappearInk = true;
             }
             this.translate.use(this.brandDetails.Language);
             localStorage.setItem('Langauge', this.brandDetails.Language);
             if( this.brandDetails.LogoSrc==null ||this.brandDetails.LogoSrc=="")
             {
                     this.showLogo=false;
                     this.showCompanyLogo = false;
             }
             else
             {
              this.showLogo=true;
              this.showCompanyLogo = true;
              this.companyLogoURL=this.brandDetails.LogoSrc;
             }}});
    }

    ngOnDestroy(): void {
      // Remove the message event listener when the component is destroyed
      window.removeEventListener('message', this.handleMessage.bind(this));
      this.subs.unsubscribe();  // Clean up subscriptions
    }
  
    // Handle the postMessage event
    handleMessage(baseUrl: string, event: MessageEvent): void {
      // Check the origin of the message for security
      if (event.origin === baseUrl) {
        if (event.data.type === 'setHeight') {
          const iframe: HTMLIFrameElement = document.getElementById('dynamicIframe') as HTMLIFrameElement;
          if (iframe) {
            iframe.style.height = `${event.data.height}px`;
            console.log('Iframe height set to:', event.data.height);
             // Adjust the height based on screen width
            if (window.innerWidth <= 768 && window.innerWidth > 375) {
              iframe.style.height = `${event.data.height + 70}px`; // Add 10px for medium screens
              console.log('Adjusted iframe height for medium screens:', event.data.height + 10);
            }

            if (window.innerWidth <= 375) {
              iframe.style.height = `${event.data.height + 70}px`; // Add 30px for smaller screens
              console.log('Adjusted iframe height for small screens:', event.data.height + 30);
            }
            if(window.innerWidth >= 768){
            const footer = document.querySelector('.branding-footer') as HTMLElement;
              if (footer) {
                if (event.data.height <= 330) {
                  footer.classList.add('fixed-footer');
                  footer.classList.remove('fixed-bottom');
                } else {
                  footer.classList.remove('fixed-footer');
                }
              }
            }
          }
        }
        
      } else {
        console.error('Received message from unknown origin:', event.origin);
      }
    }
  
    handleIframeMessage(baseUrl: string) {
      const iframe: HTMLIFrameElement = document.getElementById('dynamicIframe') as HTMLIFrameElement;
      const base64Data = btoa(JSON.stringify(this.accessDecision)); // Assuming you want to send base64 data from accessDecision.
  
      if (iframe) {
        // Wait for the iframe to load completely
        var storedThankYouUrl = sessionStorage.getItem('thankYouPage');
    
        if (storedThankYouUrl) {
            iframe.src = storedThankYouUrl; // Load the stored Thank You page URL
             //sessionStorage.setItem('thankYouPage',storedThankYouUrl);
        }
      
        iframe.onload = () => {
          const iframeOrigin = new URL(baseUrl).origin;
          const iframeWindow = iframe.contentWindow;
          if (iframeWindow && iframeOrigin) {
            // Send the message to the iframe with the correct target origin
            iframeWindow.postMessage({ type: 'sendBase64Data', data: base64Data }, iframeOrigin);
          } else {
            console.error('Iframe window or origin is not defined!');
          }
        };
        window.addEventListener('message', function (event) {
          if (event.data.type === 'navigateToThankYou') {
              sessionStorage.setItem('thankYouPage', event.data.url); // Store URL in session storage
          }
      });
    
      } else {
        console.error('Iframe not found!');
      }
    }
    // restoreThankYouPage(): void {
    //   const storedThankYouUrl = sessionStorage.getItem('thankYouPage');
    //   console.log('Stored Thank You URL:', storedThankYouUrl);
    //   if (storedThankYouUrl) {
    //     this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(storedThankYouUrl);
    //   }
    // }
}
